import { Paper, ScrollArea, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { supportApi } from '../../data-access/apis/support';

import classes from './page.module.css';

import { FullMainHeight } from '@ui';

export function ProtocolePage() {
  const { t, i18n } = useTranslation();
  const protocolsQuery = useQuery({
    queryKey: ['support', 'tutorials', i18n.language],
    queryFn: supportApi.getTutorials,
  });

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Content className={classes.content}>
        <Stack gap={0} h="100%">
          <header className={classes.header}>
            <Text className={classes.headerTitle}>{t('supportPage.protocols.title')}</Text>
          </header>

          <ScrollArea h="100%">
            <Stack className={classes.listStack} gap="md">
              {protocolsQuery.data?.length === 0 ? (
                <Paper className={classes.card} p="md" radius="lg" withBorder>
                  <Text c="dimmed" size="sm">
                    {t('supportPage.protocols.empty')}
                  </Text>
                </Paper>
              ) : null}

              {protocolsQuery.data?.map((protocol) => (
                <Paper className={classes.card} key={protocol.id} p="md" radius="lg" withBorder>
                  <div className={classes.contentRow}>
                    <Stack className={classes.textColumn} gap={10}>
                      <Text className={classes.cardTitle}>{protocol.name}</Text>
                      <span className={classes.greenBar} />
                    </Stack>
                    <div className={classes.actionsColumn}>
                      <a
                        aria-label={t('supportPage.protocols.openPdfAria', {
                          name: protocol.name,
                        })}
                        className={classes.pdfButton}
                        href={protocol.tutorial}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <FileText size={18} />
                        <span>{t('supportPage.protocols.pdf')}</span>
                      </a>
                    </div>
                  </div>
                </Paper>
              ))}
            </Stack>
          </ScrollArea>
        </Stack>
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

export default ProtocolePage;
